import { Component, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DossiersService } from '../../../services/dossiers/dossiers.service';
import { Dossier_Data } from '../../../interfaces/Dossier_Partenariat_Data';
import { SharedService } from '../../../services/shared/shared.service';
import { BreadcrumbComponent } from "../../../common/breadcrumb/breadcrumb.component";
import { verif } from '../../../helpers/decorators/verif';
import { LazyLoadable } from 'app/interfaces/LazyLoadable';
import { lazyComponents } from 'app/helpers/functions/LazyComponents';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-dossier-details',
    standalone: true,
    templateUrl: './dossier-details.component.html',
    styleUrl: './dossier-details.component.css',
    imports: [CommonModule, BreadcrumbComponent]
})
export class DossiersDetailsComponent 
{
  @ViewChild('pagesContainer', { read: ViewContainerRef }) pagesContainer!: ViewContainerRef
  private copieMessageReady$ = new Subject<void>()

  parent:string = 'Dossier'
  title!:string
  civilite!:string
  abonne!:string
  num_contrat!:string
  adresse!:string
  cp!:string
  ville!:string
  date!:Date
  date_realisation_previ!:Date
  hors_delai!:Date
  etat!:string
  liste_copie_message!:string[]
  ref!:string
  id_dossier!:number
  id_service!:number
  id_user!:number
  imgSource:string = '/assets/icons/picto-transmettreenvoi-white.png'

  parentData!:Dossier_Data
  
  gestion_dossier:boolean
  copie_message:boolean
  gestion_convention_facturation:boolean
  saisie_donnees_abonnes:boolean

  readonly tabList = Object.freeze(["suivi","documents","messages","transmettre"])
  
  constructor
  (
    private sharedService: SharedService,
    private dossiersService: DossiersService,
    private activatedRoute: ActivatedRoute,
  ) 
  {
    this.ref = this.sharedService.getParam("ref") || ""
    this.id_dossier = Number(this.sharedService.getParam("id_dossier"))
    this.id_user = this.sharedService.getIdUser()

    this.setRef()
    this.setTypeRef()
    this.setLastDossier()
    this.setLastDossierType()
    this.setLastDossierId()

    const { gestion_dossier, copie_message, gestion_convention_facturation, saisie_donnees_abonnes } = this.sharedService.getUserRights()
    this.gestion_dossier = gestion_dossier
    this.copie_message = copie_message
    this.gestion_convention_facturation = gestion_convention_facturation
    this.saisie_donnees_abonnes = saisie_donnees_abonnes
    this.id_service = this.sharedService.getIdService()

    this.parentData = {ref:this.ref, id_dossier:this.id_dossier, id_service:this.id_service, type:"dossiers"}

    this.dossiersService.postTableVisiteDossier(this.id_user, this.id_dossier, this.id_service, this.ref).subscribe()
  }

  ngOnInit()
  {
    this.copieMessageReady$.subscribe(async () => {
      const currentTab = localStorage.getItem("tab") || "suivi"

      if(currentTab == "transmettre")
      {
        await this.lazyLoadComponent(currentTab)
      }
    })

    this.activatedRoute.paramMap.subscribe(params => {
      this.title = `${this.parent} ${this.ref}`
      const id_dossier = Number(this.sharedService.getParam("id_dossier"))
      this.parentData.id_dossier = id_dossier
      this.parentData.id_service = this.id_service
      this.getDetails({ref:this.ref, id_user:this.id_user, id_dossier:this.id_dossier, id_service:this.id_service.toString()})
    })
  }

  ngAfterViewInit() 
  {
    const onglet = localStorage.getItem("tab") || "suivi"

    if( onglet )
    {
      (document.querySelector(`#${onglet}`) as HTMLButtonElement)?.click()
    }
  }

  setRef()
  {
    sessionStorage.setItem("ref",this.ref)
  }

  setTypeRef()
  {
    sessionStorage.setItem("type_ref","dossiers")
  }

  setLastDossier()
  {
    this.sharedService.setLastItem(this.ref)
  }

  setLastDossierType()
  {
    this.sharedService.setLastItemType("dossiers")
  }

  setLastDossierId()
  {
    this.sharedService.setLastItemId(this.id_dossier)
  }

  @verif()
  getDetails(params:{ref:string, id_user:string|number, id_dossier:number, id_service:string})
  {
    this.dossiersService.getDetails(params.ref, params.id_service, params.id_user).subscribe(data => {
      if(data?.[0])
      {
        this.civilite = data[0].civilite
        this.abonne = data[0].abonne
        this.num_contrat = data[0].num_contrat
        this.adresse = data[0].adresse
        this.cp = data[0].cp
        this.ville = data[0].ville
        this.date = data[0].date
        this.date_realisation_previ = data[0].date_realisation_previ
        this.etat = data[0].etat
        this.hors_delai = data[0].hors_delai
        this.liste_copie_message = data[0].liste_copie_message.split(",").sort()
        this.copieMessageReady$.next()
      }
    })
  }

  async changeTab(tab:string)
  {
    if(this.tabList.includes(tab))
    {
      await this.lazyLoadComponent(tab)
    }
  }

  async lazyLoadComponent(tab:string)
  {
    this.pagesContainer.clear()

    const loader = lazyComponents[tab]
    if (!loader) return

    localStorage.setItem("tab", tab)

    const ComponentClass = await loader()

    const componentRef: ComponentRef<LazyLoadable> = this.pagesContainer.createComponent(ComponentClass)

    componentRef.instance.data = this.parentData

    if(tab == "transmettre")
    {
      componentRef.instance.ref = this.ref
      componentRef.instance.liste_copie_message = this.liste_copie_message
      componentRef.instance.id_dossier = this.id_dossier
    }
  }
}
